module.exports = __webpack_public_path__ + "img/background.11290c19.svg";